<template>
    <el-table
      v-if="showTable"
      :data="scoreList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      :cell-style="cellStyle"
      :span-method="arraySpanMethod"
      empty-text="ไม่พบข้อมูล"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        sortable
        :index="(index) =>{ return index+1}"
        :width="widthMax < 767.98 ? '78' : widthMax < 991 ? '60' : '78'"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="หัวข้อแบประเมินออนไลน์"
        header-align="center"
        sortable
        :width="
          widthMax < 767.98
            ? '150'
            : widthMax < 1150
            ? ''
            : widthMax > 1199.98
            ? ''
            : ''
        "
      ></el-table-column>
      <el-table-column
        prop="avg"
        label="คะแนนประเมินเฉลี่ย"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '120'
            : widthMax < 1150
            ? '120'
            : widthMax > 1199.98
            ? '300'
            : '120'
        "
        sortable
      >
        <template slot-scope="scope"
          >{{ scope.row.avg ? scope.row.avg.toFixed(1) : 0 }} คะแนน</template
        >
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="วันที่และเวลาที่อัปเดต"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '120'
            : widthMax < 991
            ? '130'
            : widthMax < 1150
            ? '200'
            : widthMax > 1199.98
            ? '250'
            : ''
        "
      >
        <template slot-scope="scope">{{
          scope.row.updatedAt | dateTimeTh
        }}</template>
      </el-table-column>
    </el-table>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";

export default {
  props: {
    scoreList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == this.scoreList.length - 1) {
        if (columnIndex == 1) {
          return "text-align: right;font-weight: bold;";
        }else{
          return "font-weight: bold;";
        }
      }
      return "";
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == this.scoreList.length - 1) {
        if (columnIndex == 0) {
          return [0, 0];
        } else   {
          return [1, 2];
        }
      }
    },
  },
};
</script>